import AffiliationInfoForm from './AffiliationInfoForm';

export default AffiliationInfoForm;
